<template>
  <section id="Intro" class="section">
    <div class="section-header">
      <h1>
        Landbobank Team Challenge {{ this.$root.datetime.year }}
      </h1>
      <p class="lead">
        Landbobank Team Challenge i Holstebro, hvor teamwork og udfordringer smelter sammen!
      </p>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-body">
              <h2 class="card-title">
                Løbet afvikles {{ this.$root.datetime.day }} d.
                {{ this.$root.datetime.date }}-{{
                  this.$root.datetime.year
                }}
              </h2>
              <p class="card-text" v-if="hasMultipleRoutes">
                Alle distancer gennemføres som 2–mandshold. Der konkurreres i 3
                klasser: HERRE + MIX + DAMER, på både kort (ca.
                {{ this.$root.eventData.routes.short.distance }} km.) og lang
                (ca. {{ this.$root.eventData.routes.long.distance }} km.) - <strong>lang gennemføres kun ved 20 tilmeldte hold</strong>. Hver
                deltager er selv ansvarlig for at søge informationer omkring
                løbet og de gældende regler. Den lange distance bliver sat igang
                ca. {{ this.$root.eventData.routes.long.time }} og den korte
                ca. {{ this.$root.eventData.routes.short.time }}.
              </p>
              <p v-else class="card-text">
                Landbobank Team Challenge i Holstebro byder dig velkommen til endnu et løb. 
                Tag en partner med og saml jeres kræfter som et ustoppelig 2-mandshold, klar til at erobre tre hæsblæsende klasser: HERRE, MIX og DAMER.
              </p>
              <p class="card-text">
                Reglerne er simple, men kræver dedikation og strategisk tæft. 
                Som deltager er du ansvarlig for at indhente alle nødvendige informationer om løbet og de gældende regler. 
              </p>
              I år har vi kun én distance på <strong>cirka {{ getSingleActiveRoute.distance }} km</strong> <small>({{ getSingleActiveRoute.name }})</small>, men lad dig ikke narre af længden. 
              Denne udfordring vil teste dine grænser til det yderste, <strong>når startskuddet lyder kl. {{ getSingleActiveRoute.time }}</strong>. 
              Forbered dig på et sandt adrenalineventyr, hvor du vil blive udfordret på både fysisk og mental styrke.
              <hr />
              
              <h5 class="card-title">Sponsorer</h5>
              <p class="card-text">
                Team Challenge {{ this.$root.datetime.year }} er
                ligesom sidste år bl.a. sponsoreret af:
              </p>
              <ul>
                <li
                  v-for="sponsor in this.$root.eventData.sponsors.slice(0, 4)"
                  :key="'sponsor-link-' + sponsor.name.replace(/\s/g, '')"
                >
                  {{ sponsor.name }}
                </li>
                <li><a href="#Sponsorer">Se flere...</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-body">
              <h2 class="card-title">Generel information</h2>
              <h5 class="card-title">Forplejning</h5>
              <p class="card-text">
                Deltagerne skal være selvforsynende under hele løbet. Ved mål
                vil der være væske og frugt.
              </p>
              <hr />
              <h5 class="card-title">Ruterne</h5>
              <p class="card-text">
                Ruterne går gennem meget varieret terræn og med indlagte
                elementer af vand og andet. Ruterne vil være tydelig markeret
                med snitslinger og/eller pile. På ruten vil der være skiltet med
                vandposter, hvor løberen selv skal fylde sin beholder. Vi
                opfordrer løberne til at medbringe egen væske.
              </p>
              <hr />
              <h5 class="card-title">Affald/Miljøet</h5>
              <p class="card-text">
                Løbet foregår i uspoleret natur, derfor har man pligt til at
                fjerne ALT, hvad man medbringer under løbet. Henkastning af
                affald, eksempelvis papiret fra energibarer eller lign, kan
                medføre diskvalifikation!
              </p>
              <hr />
              <h5 class="card-title">Værdigenstande</h5>
              <p class="card-text">
                Der vil være mulighed for at aflægge tasker og andet i et område
                ved start.
              </p>
              <hr />
              <h5 class="card-title">Parkering</h5>
              <p class="card-text">
                Der vil være mulighed for parkering ved Kvickly, Føtex og
                syd-siden af Musikteatret. Er man fra byen så undlad venligst at
                tage bilen, grundet de mange andre arrangementer der også
                foregår i byen den dag.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "intro",
  computed:{
    hasMultipleRoutes:function() {
      return Object.keys(this.$root.eventData.routes).filter(r => this.$root.eventData.routes[r].active === true).length > 1;
    },
    getSingleActiveRoute: function(){
      const key = Object.keys(this.$root.eventData.routes).filter(r => this.$root.eventData.routes[r].active === true)[0];
      return this.$root.eventData.routes[key];
    }
  },
  methods: {
    isRouteDisabled: function(route){
      const key = route === 'Kort' ? 'short' : 'long';
      return !this.$root.eventData.routes[key].active;
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  background-image: linear-gradient(#ebf8ed, #d8f2dc);
}
</style>
